export type BetTypeName = "win" | "exacta" | "trifecta"

export const betTypeWin: BetTypeName = "win";
export const betTypeExacta: BetTypeName = "exacta";
export const betTypeTrifecta: BetTypeName = "trifecta";